import TouchBoard from './TouchBoard';

export default TouchBoard;